// guestTypeReducer.js
import {
  FETCH_GUEST_TYPE_REQUEST,
  FETCH_GUEST_TYPE_SUCCESS,
  FETCH_GUEST_TYPE_FAILURE,
  ADD_GUEST_TYPE_REQUEST,
  ADD_GUEST_TYPE_SUCCESS,
  ADD_GUEST_TYPE_FAILURE,
  UPDATE_GUEST_TYPE_REQUEST,
  UPDATE_GUEST_TYPE_SUCCESS,
  UPDATE_GUEST_TYPE_FAILURE,
  DELETE_GUEST_TYPE_REQUEST,
  DELETE_GUEST_TYPE_SUCCESS,
  DELETE_GUEST_TYPE_FAILURE,
} from "../action/guestTypeActions";

const initialState = {
  guestTypes: [],
  loading: false,
  error: null,
};

const guestTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GUEST_TYPE_REQUEST:
      return { ...state, loading: true };
    case FETCH_GUEST_TYPE_SUCCESS:
      return { ...state, loading: false, guestTypes: action.payload };
    case FETCH_GUEST_TYPE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case ADD_GUEST_TYPE_REQUEST:
      return { ...state, loading: true };
    case ADD_GUEST_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        guestTypes: [...state.guestTypes, action.payload],
      };
    case ADD_GUEST_TYPE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_GUEST_TYPE_REQUEST:
      return { ...state, loading: true };
    case UPDATE_GUEST_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        guestTypes: state.guestTypes.map((type) =>
          type.id === action.payload.id ? action.payload : type
        ),
      };
    case UPDATE_GUEST_TYPE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_GUEST_TYPE_REQUEST:
      return { ...state, loading: true };
    case DELETE_GUEST_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        guestTypes: state.guestTypes.filter(
          (type) => type.id !== action.payload
        ),
      };
    case DELETE_GUEST_TYPE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default guestTypeReducer;
